import AutorenewIcon from "@mui/icons-material/Autorenew";
import BlockIcon from "@mui/icons-material/Block";
import CheckIcon from "@mui/icons-material/Check";
import CloudCircleIcon from "@mui/icons-material/CloudCircle";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import ErrorIcon from "@mui/icons-material/Error";
import PendingIcon from "@mui/icons-material/Pending";
import ReplayIcon from "@mui/icons-material/Replay";
import PauseIcon from "@mui/icons-material/Pause";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { error, neutral, primary, success } from "app/themes/colors";

import {
  AMBIENT_SCRIBE_STATUSES,
  AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD,
  AMBIENT_SCRIBE_STATUS_CANCELLED,
  AMBIENT_SCRIBE_STATUS_COMPLETED,
  AMBIENT_SCRIBE_STATUS_FAILED,
  AMBIENT_SCRIBE_STATUS_PAUSED,
  AMBIENT_SCRIBE_STATUS_PROCESSING,
  AMBIENT_SCRIBE_STATUS_RECORDING,
  AMBIENT_SCRIBE_STATUS_RETRYING,
  AMBIENT_SCRIBE_STATUS_TRANSCRIBED,
  AMBIENT_SCRIBE_STATUS_UPLOADED,
  AMBIENT_SCRIBE_STATUS_UPLOADING,
  AMBIENT_SCRIBE_STATUS_UPLOAD_FAILED
} from "../medical-scribe-constants";

const SUCCESS_STATUSES = [
  AMBIENT_SCRIBE_STATUS_UPLOADED,
  AMBIENT_SCRIBE_STATUS_TRANSCRIBED,
  AMBIENT_SCRIBE_STATUS_COMPLETED
];

type UploadingStatusProps = {
  status: number | undefined;
};

export default function UploadingStatus({ status }: UploadingStatusProps) {
  return (
    <Stack direction="row" columnGap={1} alignItems="center">
      {(status === AMBIENT_SCRIBE_STATUS_RECORDING ||
        status === AMBIENT_SCRIBE_STATUS_AWAITING_UPLOAD ||
        status === AMBIENT_SCRIBE_STATUS_UPLOADING) && (
        <PendingIcon sx={{ color: neutral[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_UPLOADED && (
        <CloudCircleIcon sx={{ color: success[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_TRANSCRIBED && (
        <CheckIcon sx={{ color: success[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_UPLOAD_FAILED && (
        <ErrorIcon sx={{ color: error[700] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_PROCESSING && (
        <AutorenewIcon sx={{ color: neutral[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_COMPLETED && (
        <DoneAllIcon sx={{ color: success[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_FAILED && (
        <ErrorIcon sx={{ color: error[700] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_RETRYING && (
        <ReplayIcon sx={{ color: neutral[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_CANCELLED && (
        <BlockIcon sx={{ color: neutral[600] }} />
      )}

      {status === AMBIENT_SCRIBE_STATUS_PAUSED && (
        <PauseIcon sx={{ color: primary[600] }} />
      )}

      <Typography
        sx={{
          color:
            status === AMBIENT_SCRIBE_STATUS_PAUSED
              ? primary[700]
              : SUCCESS_STATUSES.includes(status ?? -1)
                ? success[800]
                : neutral[800],
          fontWeight:
            status === AMBIENT_SCRIBE_STATUS_TRANSCRIBED ? 700 : undefined
        }}
      >
        {AMBIENT_SCRIBE_STATUSES.getFromCode(status)}
      </Typography>
    </Stack>
  );
}
